import React, { useEffect, useState } from "react";
import {
  Button,
  Flex,
  InputNumber,
  Input,
  Select,
  Table,
  TableColumnsType,
  notification,
} from "antd";
import { Home2 } from "iconsax-react";
import Layout from "../../components/layouts/Layout";
import BreadcrumbBlock from "../../components/BreadcrumbBlock/BreadcrumbBlock";
import { Link } from "react-router-dom";
import { mixPostV1 } from "../../services/mixin";
import "./style.scss";

interface PackageRow {
  key: number;
  type_id: number;
  type_name: string;
  service_id: number;
  duration: number | null;
  income: number | null;
}

const serviceOptions = [
  { value: 1, label: "Full Service" },
  { value: 2, label: "Match Only" },
  { value: 3, label: "Full Service + Automation report" },
];

const SettingTypePackage: React.FC = () => {
  const [packages, setPackages] = useState<PackageRow[]>([]);
  const [trialDays, setTrialDays] = useState<number>(30);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [api, contextHolder] = notification.useNotification();

  const getSettingTypes = async () => {
    const res = await mixPostV1("/api/webAdmin/gSettingTypeStore.php", {});
    if (res.status) {
      setTrialDays(res?.trial_days ?? 30);
      setPackages(
        res.data.map((item: any, idx: number) => ({
          key: item.type_id ?? idx,
          type_id: item.type_id,
          type_name: item.type_name ?? "",
          service_id: item.service_id ?? 1,
          duration: item.duration ?? null,
          income: item.income ?? null,
        })),
      );
    }
  };

  useEffect(() => {
    getSettingTypes();
  }, []);

  const updateRow = (key: number, field: keyof PackageRow, value: any) => {
    setPackages((prev) =>
      prev.map((row) => (row.key === key ? { ...row, [field]: value } : row)),
    );
  };

  const addPackage = () => {
    setPackages((prev) => [
      ...prev,
      {
        key: Date.now(),
        type_id: 0,
        type_name: "",
        service_id: 1,
        duration: null,
        income: null,
      },
    ]);
  };

  const onUpdate = async () => {
    setConfirmLoading(true);
    // const typeInfo = packages.map((pkg) => ({
    //   type_id: pkg.type_id,
    //   income: pkg.income,
    // }));
    const res = await mixPostV1("/api/webAdmin/updateSettingTypeStore.php", {
      typeInfo: JSON.stringify(
        packages.filter(
          (pkg) =>
            pkg.income !== null &&
            pkg.duration !== null &&
            pkg.type_name.trim() !== "",
        ),
      ),
      trial_days: trialDays,
    });
    if (res.status) {
      setConfirmLoading(false);
      getSettingTypes();
      openNotification();
    } else {
      setConfirmLoading(false);
      openNotification("error", "Something went wrong!");
    }
  };

  const openNotification = (
    type: "success" | "info" | "warning" | "error" = "success",
    message = "Account updated!",
  ) => {
    api[type]({
      message,
      placement: "bottomRight",
      className: "single-message",
    });
  };

  const columns: TableColumnsType<PackageRow> = [
    {
      title: "Package",
      dataIndex: "type_name",
      width: 220,
      render: (value, record) => (
        <Input
          className="rs-input"
          value={value}
          onChange={(e) => updateRow(record.key, "type_name", e.target.value)}
        />
      ),
    },
    {
      title: "Service",
      dataIndex: "service_id",
      render: (value, record) => (
        <Select
          value={value}
          options={serviceOptions}
          onChange={(val) => updateRow(record.key, "service_id", val)}
          style={{ width: "100%" }}
          popupClassName="rs-select-dropdown"
        />
      ),
    },
    {
      title: "Duration",
      dataIndex: "duration",
      render: (value, record) => (
        <InputNumber
          className="rs-input"
          value={value}
          min={1}
          style={{ width: "100%" }}
          onChange={(val) => updateRow(record.key, "duration", val)}
        />
      ),
    },
    {
      title: "Original Price",
      dataIndex: "income",
      render: (value, record) => (
        <InputNumber
          className="rs-input"
          value={value}
          min={0}
          style={{ width: "100%" }}
          onChange={(val) => updateRow(record.key, "income", val)}
        />
      ),
    },
  ];

  return (
    <>
      {contextHolder}
      <Layout className="match-height" contentClassName="setting-layout">
        <BreadcrumbBlock
          items={[
            {
              title: (
                <Flex align="center" gap={16}>
                  <Home2 variant="Bulk" />
                  <Link to="/">CMD Tech</Link>
                </Flex>
              ),
            },
            { title: "Setting type" },
          ]}
          title="Setting type"
          description=""
        />

        <div className="setting-content setting-content--update fl-columns-991">
          <div style={{ width: "100%" }}>
            <Flex vertical gap={16}>
              <div className="title-12 text-idle">
                Edit and click <span className="font-bold">Update</span> if you
                want to change anything
              </div>

              <Flex align="center" gap={8}>
                <span className="title-12 text-idle">
                  Trial Duration (in days)
                </span>
              </Flex>
              <Flex align="center" gap={12}>
                <span className="label" style={{ color: "#fff", fontSize: 14 }}>
                  Trial days
                </span>
                <InputNumber
                  className="rs-input widht-25"
                  value={trialDays}
                  onChange={(value) => setTrialDays(Number(value))}
                />
              </Flex>

              <Table
                className="rs-table"
                dataSource={packages}
                columns={columns}
                pagination={false}
                rowKey="key"
              />

              <div>
                <Button
                  className="rs-button"
                  onClick={addPackage}
                  style={{ marginTop: 4, borderColor: "#555", color: "#ccc" }}
                >
                  Add New Package
                </Button>
              </div>
            </Flex>
          </div>

          <Button
            className="rs-button button-update"
            type="primary"
            loading={confirmLoading}
            onClick={onUpdate}
          >
            Update
          </Button>
        </div>
      </Layout>
    </>
  );
};

export default SettingTypePackage;
